import { Link } from "react-router";
import { DownloadIcon, SaveIcon } from "../../../../../../assets/icons";
import { ModelsItemType } from "../../../../../models";
import {
  downloadFile,
  isViewedItem,
  saveViewedItem,
} from "../../../../../utils";
import { getText, sanitizeHtml } from "../../../../../utils/_generic";
import {
  getHighlightedExcerpts,
  highlightFullText,
} from "../../../../../utils/_getHighlightedExcerpts";
import PDLTypography from "../../../dna/_pdltypography";
import { ActionButton } from "../../../global/_actionButton";

export interface ModelsItemProps {
  item: ModelsItemType;
  index: number;
  searchTerm?: string;
}

const ModelItem = ({ item, index, searchTerm }: ModelsItemProps) => {
  const itemId = item._id || `generic-${index}`;
  const sanitizedHtml = sanitizeHtml(item.texto || "");
  const textOnly = getText(sanitizedHtml);

  const excerpt = getHighlightedExcerpts(textOnly, searchTerm, 150);

  const opened = isViewedItem(itemId);

  const handleDownloadFile = () => {
    const wordUrl = `https://produtos.lex.com.br${item.versaoWord}`;

    downloadFile({
      name: item.titulo || "arquivo.docx",
      url: wordUrl,
    });
  };

  const fullTitle = item?.titulo || "";

  const highlightedTitle = highlightFullText(fullTitle || "", searchTerm);

  const displayTitle = highlightedTitle ? highlightedTitle : fullTitle || "";

  const cleanTitle = sanitizeHtml(displayTitle);

  return (
    <div
      key={itemId}
      id={`result-item-${itemId}`}
      className={`pdl_components_lista_resultados_item mt-3 ${
        opened ? "opened" : ""
      }`}
    >
      <header className="title-wrapper">
        <Link
          to={`/modelos/${item._id}`}
          className="text-decoration-none"
          onClick={() => {
            saveViewedItem(itemId);
            sessionStorage.setItem("last-clicked-result-item", itemId);
          }}
        >
          <PDLTypography
            size="md"
            weight="semibold"
            variant="brand"
            upper
            className="title-link"
          >
            <span
              className="pdl-title-clamp-3"
              dangerouslySetInnerHTML={{
                __html: `${
                  opened ? `<span class="opened-status">Acessado</span>` : ""
                } ${cleanTitle}`,
              }}
            />
          </PDLTypography>
        </Link>
      </header>

      <div className="result-meta mb-2 mt-2 flex justify-between items-start">
        <div className="flex">
          <PDLTypography as="span" size="sm">
            Modelos
          </PDLTypography>
          {item.tipo && (
            <>
              &nbsp;&bull;&nbsp;
              <PDLTypography as="span" size="sm">
                {item.tipo}
              </PDLTypography>
            </>
          )}
          {item.area?.length > 0 && (
            <>
              &nbsp;&bull;&nbsp;
              <PDLTypography as="span" size="sm">
                {item.area}
              </PDLTypography>
            </>
          )}
          {item.categoria && (
            <>
              &nbsp;&bull;&nbsp;
              <PDLTypography as="span" size="sm">
                {item.categoria}
              </PDLTypography>
            </>
          )}
        </div>

        <div className="btn-action-container flex gap-2">
          <ActionButton icon={<SaveIcon />} label="Salvar" />
          <ActionButton
            icon={<DownloadIcon />}
            label="Baixar em Word"
            onClick={handleDownloadFile}
          />
        </div>
      </div>

      <div className="text-container">
        {!!excerpt && (
          <PDLTypography
            size="sm"
            weight="medium"
            className="text-gray-800 mb-1"
          >
            Texto encontrado em:
          </PDLTypography>
        )}

        <div
          className="content text-sm text-gray-800"
          dangerouslySetInnerHTML={{
            __html: excerpt || textOnly.slice(0, 500),
          }}
        />
      </div>
    </div>
  );
};

export default ModelItem;
